/**
 * Map rotation_family -> soft earthy tint for crop chips.
 * Kept within the existing --vm-* palette so the grid never clashes with
 * the overall journal aesthetic.
 */
export const FAMILY_TOKENS = {
    leafy: {
        bg: "bg-[#C8D6B9]",
        border: "border-[#A3B19B]",
        text: "text-[#2C3625]",
        label: "leafy",
    },
    brassica: {
        bg: "bg-[#D7E1CA]",
        border: "border-[#A3B19B]",
        text: "text-[#2C3625]",
        label: "brassica",
    },
    solanaceae: {
        bg: "bg-[#F1D7C7]",
        border: "border-[#C25934]",
        text: "text-[#8C2F12]",
        label: "solanaceae",
    },
    cucurbit: {
        bg: "bg-[#F5E3BE]",
        border: "border-[#D99A45]",
        text: "text-[#6B4A14]",
        label: "cucurbit",
    },
    legume: {
        bg: "bg-[#D4E1C3]",
        border: "border-[#4A6741]",
        text: "text-[#2C3625]",
        label: "legume",
    },
    allium: {
        bg: "bg-[#E6D7CC]",
        border: "border-[#8C6A5D]",
        text: "text-[#3B3228]",
        label: "allium",
    },
    umbellifer: {
        bg: "bg-[#E8B991]",
        border: "border-[#C25934]",
        text: "text-[#6B2510]",
        label: "umbellifer",
    },
    root: {
        bg: "bg-[#D6C4AE]",
        border: "border-[#8C6A5D]",
        text: "text-[#3B3228]",
        label: "root",
    },
    herb: {
        bg: "bg-[#DDE7D6]",
        border: "border-[#6B7F5C]",
        text: "text-[#2C3625]",
        label: "herb",
    },
    perennial: {
        bg: "bg-[#E8DCC9]",
        border: "border-[#8C6A5D]",
        text: "text-[#5C4530]",
        label: "perennial",
    },
    flower: {
        bg: "bg-[#FBE3D5]",
        border: "border-[#D99A45]",
        text: "text-[#8C2F12]",
        label: "flower",
    },
    other: {
        bg: "bg-[#F2EFE9]",
        border: "border-[#E3DECC]",
        text: "text-[#5C6656]",
        label: "other",
    },
};

export const familyToken = (family) => FAMILY_TOKENS[family] || FAMILY_TOKENS.other;
